import { createContext, useContext, useMemo, useState } from "react";

import Service from "../api/service";

const DashboardContext = createContext(null);

export const useDashboardContext = () => {
  const v = useContext(DashboardContext);
  if (!v) {
    throw new Error(
      "useDashboardContext must be used inside DashboardProvider",
    );
  }
  return v;
};

export const DashboardProvider = ({ children }) => {
  const [stats, setStats] = useState(null);
  const [table, setTable] = useState(null);

  const fetchData = async () => {
    const response = await Service.get("/api/v1/stats/country");
    if (response?.data !== undefined) setStats(response.data);
    return response;
  };

  const getTableData = async () => {
    const response = await Service.get("/api/v1/stats/table");
    if (response?.data !== undefined) setTable(response.data);
    return response;
  };

  const value = useMemo(
    () => ({ stats, table, fetchData, getTableData }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [stats, table],
  );

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};
